import React from "react";
import { PlatformIcon, platformList } from "./PlatformIcon";

const PlatformsMarquee = () => {
  const items = [...platformList, ...platformList]; // duplicate for seamless loop

  return (
    <section className="relative py-16 border-y border-white/5 bg-[#070707]" data-testid="platforms-marquee">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-8 flex items-center gap-4">
        <span className="font-mono-c text-[10px] uppercase tracking-[0.25em] text-[#00FF88]">
          Connect Your Gig Platforms
        </span>
        <span className="text-white/60 text-sm">6+ gig platforms · Built for gig workers · Powered by real earnings</span>
      </div>
      <div className="marquee-mask overflow-hidden">
        <div className="marquee-track flex items-center gap-10 px-6">
          {items.map((p, i) => (
            <div
              key={i}
              className="shrink-0 flex items-center gap-3 px-5 py-3 rounded-2xl bg-[#0A0A0A] border border-white/5 hover:border-[#00FF88]/40 transition-colors"
            >
              <PlatformIcon id={p.id} size={32} />
              <span className="font-display font-bold text-white/80 text-lg whitespace-nowrap">
                {p.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformsMarquee;
